import * as React from 'react'
import { User } from '../sdk/api/models/user'

export const UserContext = React.createContext<User>(undefined as any)
export const UserContextProvider = UserContext.Provider
export const UserContextConsumer = UserContext.Consumer